<template>
  <div>
    <!-- 操作 -->
    <div class="operate">
      <!--全选  -->
      <el-checkbox v-model="$parent.checked" @change="allChecked">
        {{ $t("message.allChecked") }}</el-checkbox>
      <!-- 印装箱单 -->
      <el-button size="small" type="success" @click="printPackingList('')">{{ $t("message.printPackingList") }}
      </el-button>
      <!-- 打印装箱单(无单价)-->
      <el-button size="small" type="success" @click="printPackingList('NoPrice')">
        {{ $t("message.printPackingListNoPrice") }}
      </el-button>
      <!-- 配货打印唛头 -->
      <el-button size="small" type="primary" class="secondary " @click="shippingMarkForDistribution">
        {{ $t("message.shippingMarkForDistribution") }}
      </el-button>
      <!-- 给配货打印 -->
      <el-button size="small" type="primary" @click="printForDistribution">
        给配货打印
      </el-button>
      <!-- 打印废弃单 -->
      <el-button size="small" type="primary" @click="abandonedList" v-if="detail.discard_status">
        {{ $t("message.abandonedList") }}
      </el-button>
      <!-- 售中问题提出 -->
      <el-button size="mini" type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>

      <!-- 国际物流配送提出 detail.co_porder_sn == '' 集运副单 不能操作-->
      <el-button size="small" type="success" class="fr" @click="submitDelivery"
        v-if="isAuth(260) && detail.co_porder_sn == ''">
        {{ $t("message.internationalLogisticsDistributionIsProposed") }}
      </el-button>
      <!-- 国际运费计算 -->
      <el-button size="small" type="primary" class="secondary fr" @click="InternationalFreight">
        {{ $t("message.internationalFreightCalculation") }}
      </el-button>
      <!-- 批量填写物流单号 -->
      <el-button size="small" type="primary" class="fr" @click="fillInTheLogisticsNumberInBatches"
        v-if="isAuth(261) && detail.co_porder_sn == ''">
        {{ $t("message.fillInTheLogisticsNumberInBatches") }}
      </el-button>
      <!-- 获取物流单号 -->
      <el-popover placement="bottom" width="200" trigger="click" v-if="detail.co_porder_sn == ''">
        <el-select v-model="value" placeholder="请选择" @change="changeLogistics" filterable clearable>
          <el-option v-for="item in logistics" :key="item.id" :label="item.name" :value="item.id"
            v-show="item.is_auto_no == 1">
          </el-option>
        </el-select>
        <!-- {{ logistics }} -->
        <el-button size="small" type="primary" class="fr" slot="reference">
          {{ $t("message.obtainTheLogisticsTrackingNumber") }}
        </el-button>
      </el-popover>
      <!-- 配送单重新报价 -->
      <el-button size="small" type="success" class="fr dark" @click="requotationOfDeliveryOrder"
        v-if="isAuth(263) && detail.co_porder_sn == ''">
        {{ $t("message.requotationOfDeliveryOrder") }}
      </el-button>
      <!-- 业务唛头打印 -->
      <el-button size="small" type="primary" class="fr" @click="serviceShippingMarkPrint" v-if="isAuth(262)">
        {{ $t("message.serviceShippingMarkPrint") }}
      </el-button>

      <!-- 唛头打印 -->
      <div v-show="false">
        <div ref="boxshippingmark" v-if="prinData != false">
          <boxshippingmark :prinData="prinData" />
        </div>
      </div>
      <!-- 装箱打印 -->
      <div v-show="false">
        <div ref="Packinglist">
          <Packinglist :datas="item" v-for="(item, index) in PackingData" :key="index" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import boxshippingmark from "@/components/Printedsheet/boxshippingmark";
import Packinglist from '@/components/Printedsheet/Packinglist'
export default {
  props: {
    selectedList: { type: Array },
  },
  components: {
    boxshippingmark,
    Packinglist
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      logistics_id: "",
      visible: false,
      value: "",
      PackingData: [],
      prinData: []
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.porderDetail.detail,
      boxList: (state) => state.porderDetail.boxList,
      list: (state) => state.porderDetail.list,
    }),
    // 只能选择的物流方式
    logistics() {
      let list = []
      this.boxList.forEach(item => {
        item.group.forEach(group => {
          this.logisticsList.forEach(logistics => {
            if (logistics.id == group.logistics_id) {
              list.push(logistics)
            }
          })
        })
      })
      var hash = {};
      list = list.reduce(function (item, next) {
        hash[next.id]
          ? ""
          : (hash[next.id] = true && item.push(next));

        return item;
      }, []);
      return list
    },
  },
  mounted() {
    this.$parent.$refs.getNotice.getNotice(this.detail.user_id, '配货注意事项')
    if (!this.list.every(item => item.inSale == false)) {
      this.$alert("当前配送单有配送单相关售中问题产品未处理完成，装箱时请注意！！！", "提醒", {
        confirmButtonText: "确定",
        center: true,
        callback: action => {
        }
      });
    }
  },
  methods: {
    //全选
    allChecked() {
      this.$emit("allChecked");

    },

    // 国际物流计算
    InternationalFreight() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.InternationalFreight.dialogVisible = true;
    },
    //配送单回退重新报价记录
    requotationOfDeliveryOrder() {
      this.$parent.$refs.requotationOfDeliveryOrder.dialogVisible = true;
    },
    // 批量填写物流单号
    fillInTheLogisticsNumberInBatches() {
      let boxArr = [];
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          let flag = items.list.some((box) => box.checked);
          if (flag) {
            let datas = {
              porder_sn: item.porder_sn,
              list: [],
            };
            items.list.forEach((box) => {
              if (box.checked) {

                datas.list.push({ id: box.id, number: box.number });
              }
            });
            boxArr.push(datas);
          }
        });
      });
      if (boxArr == false)
        return this.$message.error("未选择箱子，不能进行批量填写物流单号");
      console.log(boxArr);
      this.$store.commit("setWuliuFillIn", boxArr);
      this.$parent.$refs.wuliuFillIn.dialogVisible = true;
    },
    //国际派送提出
    submitDelivery() {
      this.$confirm(
        this.$t("message.isInternationalLogisticsDistributionIsProposed"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .submitDelivery({ porder_sn: this.porder_sn })
            .then((res) => {
              // 有抽查的 是否跳过抽查
              if (res.code == 10006) {
                this.skipSpotCheck(res.msg)
                return false
              }
              this.$message.success(res.msg);
              setTimeout(() => {
                this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
                window.open("about:blank", "_top").close();

              }, 1000)
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 跳过抽查
    skipSpotCheck(msg) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .submitDelivery({ porder_sn: this.porder_sn, reconfirm: 1 })
            .then((res) => {
              this.$message.success(res.msg);
              setTimeout(() => {
                this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
                window.open("about:blank", "_top").close();

              }, 1000)
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 获取物流单号
    changeLogistics(e) {
      this.$api.siteConfiguration
        .getNewNumber({ logistics_id: e })
        .then((res) => {
          this.copy(res.data)
          this.value = ''
          if (this.boxIds != false) {
            this.updateExpressNo(res.data)
          }
        });
    },

    // 业务唛头打印
    serviceShippingMarkPrint() {
      let boxIds = [];
      let logistics_name = []
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          let flag = items.list.some((box) => box.checked);

          if (flag) {
            logistics_name.push(items.logistics_name)
          }
          items.list.forEach((box) => {
            if (box.checked) {
              boxIds.push(box.id);
            }
          });
        });
      });
      if (boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      // if (logistics_name.length > 1)
      //   return this.$message.error(
      //     '只能选择一种物流方式'
      //   );
      let logistics = logistics_name[0]
      if (logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便') {
        this.$api.porderApi.kilospeedMark({ freightIds: boxIds }).then(res => {
          res.data.forEach((item, index) => {
            item.boxTotal = boxIds.length
            item.num = index + 1
            item.logistics = logistics
          })
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)
          this.$nextTick(() => {
            this.$print(this.$parent.$refs.KS_JPShippingmark);
            this.$store.commit('setPrintData', {})
          });
        })
      } else {
        this.$api.getMaitouData({ freightIds: boxIds }).then(res => {
          res.data.forEach(item => {
            item.boxTotal = boxIds.length
          })
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)

          if (logistics == 'EMS') {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.EMSprintingmark);
              this.$store.commit('setPrintData', {})
            });
          } else if (logistics == 'TW船便') {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.TWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
            });
          } else if (logistics == 'RW船便') {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.RWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
            });

          } else if (logistics == 'Raku-DQ') {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.Raku_DQShippingmark);
              this.$store.commit('setPrintData', {})
            });

          }
          else if (logistics == 'OCS') {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.OCSCustomerShippingmark);
              this.$store.commit('setPrintData', {})
            });

          } else {
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.DQShippingmark);
              this.$store.commit('setPrintData', {})
            });

          }
        })
      }

    },

    //配货打印唛头
    shippingMarkForDistribution() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );

      this.$api.getMaitouData({ freightIds: this.boxIds, not_print: 1 }).then((res) => {
        res.data.forEach(item => {
          item.boxTotal = this.boxIds.length
        })
        this.prinData = res.data;
        this.$nextTick(() => {
          this.$print(this.$refs.boxshippingmark);
          this.prinData = []
        });
      });
    },
    // 批量填写物流单号
    updateExpressNo(express_no) {
      let datas = {
        express_no,
        freight_id_set: this.boxIds,
      };
      this.$api.porderApi.updateExpressNo(datas).then((res) => {
        this.boxList.forEach((item) => {
          item.group.forEach((items) => {
            items.list.forEach((box) => {
              if (box.checked) {
                box.express_no = express_no
              }
            });
          });

        });
        this.$alert("物流单号：" + express_no + "。已填充到勾选的箱子上", "提示", {
          confirmButtonText: "确定",
          center: true,
        });

        this.$forceUpdate()
      });
    },
    //打印装箱单
    printPackingList(type) {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.porderApi.boxDetailBatchPrint({ freight_id_set: this.boxIds }).then(res => {
        res.data.forEach(item => {
          item.total = 0
          item.porder_freight_detail.forEach(items => {
            item.total += items.num
            if (type) {
              items.order_detail.confirm_price = ''
            }
          })
        })
        this.PackingData = res.data;
        console.log(this.PackingData);
        this.$nextTick(() => {
          this.$print(this.$refs.Packinglist);
        });
      })
    },
    //打印废弃单
    abandonedList() {
      let boxIds = []
      this.boxList.forEach(item => {
        item.group.forEach(items => {
          items.list.forEach(box => {
            boxIds.push(box.id);
          })
        })
      })
      this.$api.porderApi.discardList({ porder_sn: this.porder_sn }).then(res => {
        let itemData = res.data.data[0]
        this.$api.getMaitouData({ freightIds: boxIds }).then((res) => {
          res.data.forEach((item) => {
            item.boxTotal = boxIds.length;
            item.reason = itemData.reason
            item.created_at = itemData.created_at
            item.abandon = itemData.abandon_type == 1 ? '客户要求废弃' : '联系不上超时废弃'
            // 二维码
            this.$QRCode.toDataURL(
              item.encrypt_freight_id,
              { errorCorrectionLevel: "L", margin: 2, width: 128 },
              (err, url) => {
                if (err) throw err;
                item.QRImgUrl = url;
              }
            );
          });
          let datas = {
            logistics: '废弃',
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)

          this.$nextTick(() => {
            this.$print(this.$parent.$refs.abandoned);
            this.$store.commit('setPrintData', {})
          });
        });
      })



    },
    //给配货打印
    printForDistribution() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      let logistics_name = []
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          let flag = items.list.some((box) => box.checked);
          if (flag) {
            logistics_name.push(items.logistics_name)
          }
        });
      });
      let logistics = logistics_name[0]
      let freightIds = this.boxIds.join(',')
      this.copy(`https://manage.rakumart.com/#/printForDistribution?freightIds=${freightIds}&porder_md5=${this.$md5(this.porder_sn)}&logistics=${encodeURIComponent(logistics)}`)
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      this.$parent.$refs.inSalePreview.storePreview(ids)
    },
  },
};
</script>
<style lang='scss' scoped>
.operate {
  margin: 0 24px;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
  line-height: 32px;

  .el-button {
    margin-left: 30px;
  }
}
</style>